import _extends from "babel-runtime/helpers/extends";
import React from 'react';

export var Loading = function Loading(props) {
  return React.createElement(
    "svg",
    _extends({}, props, {
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 50 50",
      xmlSpace: "preserve" }),
    React.createElement(
      "path",
      { d: "M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z" },
      React.createElement("animateTransform", {
        attributeType: "xml",
        attributeName: "transform",
        type: "rotate",
        from: "0 25 25",
        to: "360 25 25",
        dur: "0.9s",
        repeatCount: "indefinite"
      })
    )
  );
};

export var ArrowLeft = function ArrowLeft(props) {
  return React.createElement(
    "svg",
    _extends({}, props, {
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 5 8",
      xmlSpace: "preserve" }),
    React.createElement(
      "g",
      {
        transform: "translate(2.500000, 4.000000) rotate(90.000000) translate(-2.500000, -4.000000) translate(-1.000000, 2.000000)",
        strokeWidth: "1.5" },
      React.createElement("polyline", {
        transform: "translate(3.500000, 2.000000) rotate(-90.000000) translate(-3.500000, -2.000000) ",
        points: "5 -1 2 2 5 5"
      })
    )
  );
};

export var ArrowRight = function ArrowRight(props) {
  return React.createElement(
    "svg",
    _extends({}, props, {
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 6 9",
      xmlSpace: "preserve" }),
    React.createElement(
      "g",
      {
        transform: "translate(3.000000, 4.500000) scale(-1, 1) rotate(90.000000) translate(-3.000000, -4.500000) translate(-0.500000, 2.500000)",
        strokeWidth: "1.5" },
      React.createElement("polyline", {
        transform: "translate(3.500000, 2.000000) rotate(-90.000000) translate(-3.500000, -2.000000) ",
        points: "5 -1 2 2 5 5"
      })
    )
  );
};

export var Checked = function Checked(props) {
  return React.createElement(
    "svg",
    _extends({}, props, {
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 405.272 405.272",
      xmlSpace: "preserve" }),
    React.createElement(
      "g",
      null,
      React.createElement("path", {
        d: "M393.401,124.425L179.603,338.208c-15.832,15.835-41.514,15.835-57.361,0L11.878,227.836 c-15.838-15.835-15.838-41.52,0-57.358c15.841-15.841,41.521-15.841,57.355-0.006l81.698,81.699L336.037,67.064 c15.841-15.841,41.523-15.829,57.358,0C409.23,82.902,409.23,108.578,393.401,124.425z"
      })
    )
  );
};

export var Send = function Send(props) {
  return React.createElement(
    "svg",
    _extends({}, props, {
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 12 12",
      xmlSpace: "preserve" }),
    React.createElement(
      "g",
      { transform: "translate(-2 -2)" },
      React.createElement("path", { d: "M2.75421588,2.04520025 C2.56915168,1.95941392 2.35556002,1.9976684 2.20507526,2.14355189 C2.05459051,2.28943538 1.99395981,2.51701856 2.04919474,2.72866446 L2.88690303,6.21325741 L12.543689,7.99324788 L2.87318037,9.79364281 L2.01689693,13.2842371 C1.96675776,13.4948877 2.03021345,13.7184475 2.18055466,13.8608173 C2.33089587,14.0031871 2.54201478,14.0396435 2.72504871,13.9548413 C10.2397635,10.7640383 13.9980804,8.77686902 13.9999993,7.99333361 C14.0019182,7.2097982 10.2533237,5.22708708 2.75421588,2.04520025 Z" })
    )
  );
};

export var Plus = function Plus(props) {
  return React.createElement(
    "svg",
    _extends({}, props, {
      className: "plus",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 42 42",
      xmlSpace: "preserve" }),
    React.createElement("path", {
      d: "M37.059,16H26V4.941C26,2.224,23.718,0,21,0s-5,2.224-5,4.941V16H4.941C2.224,16,0,18.282,0,21s2.224,5,4.941,5H16v11.059 C16,39.776,18.282,42,21,42s5-2.224,5-4.941V26h11.059C39.776,26,42,23.718,42,21S39.776,16,37.059,16z"
    })
  );
};
export var Copy = function Copy(props) {
  return React.createElement(
    "svg",
    _extends({}, props, {
      width: "12px",
      height: "12px",
      viewBox: "0 0 12 12",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink" }),
    React.createElement(
      "g",
      { id: "09-\u2013-Settings", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
      React.createElement(
        "g",
        {
          id: "09_04_01--GipsyBot--settings",
          transform: "translate(-1034.000000, -326.000000)",
          fill: "#ADABBC",
          fillRule: "nonzero" },
        React.createElement(
          "g",
          { id: "Me", transform: "translate(320.000000, 176.000000)" },
          React.createElement(
            "g",
            { id: "Intro", transform: "translate(0.000000, 64.000000)" },
            React.createElement(
              "g",
              { id: "input", transform: "translate(0.000000, 72.000000)" },
              React.createElement(
                "g",
                { id: "btn", transform: "translate(714.000000, 12.000000)" },
                React.createElement(
                  "g",
                  { id: "Icon/12/Copy", transform: "translate(0.000000, 2.000000)" },
                  React.createElement("path", { d: "M6.17777778,5.06666667 C5.56412806,5.06666667 5.06666667,5.56412806 5.06666667,6.17777778 L5.06666667,9.55555556 C5.06666667,10.1692053 5.56412806,10.6666667 6.17777778,10.6666667 L9.55555556,10.6666667 C10.1692053,10.6666667 10.6666667,10.1692053 10.6666667,9.55555556 L10.6666667,6.17777778 C10.6666667,5.56412806 10.1692053,5.06666667 9.55555556,5.06666667 L6.17777778,5.06666667 Z M6.17777778,3.73333333 L9.55555556,3.73333333 C10.9055849,3.73333333 12,4.82774839 12,6.17777778 L12,9.55555556 C12,10.9055849 10.9055849,12 9.55555556,12 L6.17777778,12 C4.82774839,12 3.73333333,10.9055849 3.73333333,9.55555556 L3.73333333,6.17777778 C3.73333333,4.82774839 4.82774839,3.73333333 6.17777778,3.73333333 Z M2.26666667,6.93333333 C2.6348565,6.93333333 2.93333333,7.23181017 2.93333333,7.6 C2.93333333,7.96818983 2.6348565,8.26666667 2.26666667,8.26666667 L1.73333333,8.26666667 C0.776039767,8.26666667 0,7.4906269 0,6.53333333 L0,1.73333333 C0,0.776039767 0.776039767,0 1.73333333,0 L6.53333333,0 C7.4906269,0 8.26666667,0.776039767 8.26666667,1.73333333 L8.26666667,2.26666667 C8.26666667,2.6348565 7.96818983,2.93333333 7.6,2.93333333 C7.23181017,2.93333333 6.93333333,2.6348565 6.93333333,2.26666667 L6.93333333,1.73333333 C6.93333333,1.51241943 6.75424723,1.33333333 6.53333333,1.33333333 L1.73333333,1.33333333 C1.51241943,1.33333333 1.33333333,1.51241943 1.33333333,1.73333333 L1.33333333,6.53333333 C1.33333333,6.75424723 1.51241943,6.93333333 1.73333333,6.93333333 L2.26666667,6.93333333 Z" })
                )
              )
            )
          )
        )
      )
    )
  );
};

export var Close = function Close(props) {
  return React.createElement(
    "svg",
    _extends({}, props, {
      className: "close",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 8 8",
      xmlSpace: "preserve" }),
    React.createElement(
      "g",
      { stroke: "none", strokeWidth: "1", fillRule: "evenodd" },
      React.createElement(
        "g",
        { transform: "translate(-1576.000000, -16.000000)" },
        React.createElement("path", { d: "M1580,18.8686292 L1582.63431,16.2343146 C1582.94673,15.9218951 1583.45327,15.9218951 1583.76569,16.2343146 C1584.0781,16.546734 1584.0781,17.053266 1583.76569,17.3656854 L1581.13137,20 L1583.76569,22.6343146 C1584.0781,22.946734 1584.0781,23.453266 1583.76569,23.7656854 C1583.45327,24.0781049 1582.94673,24.0781049 1582.63431,23.7656854 L1580,21.1313708 L1577.36569,23.7656854 C1577.05327,24.0781049 1576.54673,24.0781049 1576.23431,23.7656854 C1575.9219,23.453266 1575.9219,22.946734 1576.23431,22.6343146 L1578.86863,20 L1576.23431,17.3656854 C1575.9219,17.053266 1575.9219,16.546734 1576.23431,16.2343146 C1576.54673,15.9218951 1577.05327,15.9218951 1577.36569,16.2343146 L1580,18.8686292 Z" }),
        React.createElement("use", { fill: "#8A8D96", fillRule: "nonzero", xlinkHref: "#path-1" })
      )
    )
  );
};

export var Substract = function Substract(props) {
  return React.createElement(
    "svg",
    _extends({}, props, {
      className: "substract",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 42 42",
      xmlSpace: "preserve" }),
    React.createElement("path", {
      d: "M37.059,16H26H16H4.941C2.224,16,0,18.282,0,21s2.224,5,4.941,5H16h10h11.059C39.776,26,42,23.718,42,21 S39.776,16,37.059,16z"
    })
  );
};

export var Calendar = function Calendar(props) {
  return React.createElement(
    "svg",
    _extends({}, props, {
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      x: "0px",
      y: "0px",
      viewBox: "0 0 16 16",
      xmlSpace: "preserve" }),
    React.createElement(
      "g",
      { stroke: "none", strokeWidth: "1", fillRule: "evenodd" },
      React.createElement(
        "g",
        { transform: "translate(-888.000000, -136.000000)", fill: "#ADB5BD", fillRule: "nonzero" },
        React.createElement(
          "g",
          { transform: "translate(760.000000, 0.000000)" },
          React.createElement(
            "g",
            { transform: "translate(128.000000, 128.000000)" },
            React.createElement("path", { d: "M14.1997099,9.52357402 L12.5694857,9.52357402 L12.5694857,8.76178701 C12.5694857,8.34106366 12.228422,8 11.8076987,8 C11.3869753,8 11.0459116,8.34106366 11.0459116,8.76178701 L11.0459116,9.52357402 L4.95161557,9.52357402 L4.95161557,8.76178701 C4.95161557,8.34106366 4.6105519,8 4.18982856,8 C3.76910521,8 3.42804155,8.34106366 3.42804155,8.76178701 L3.42804155,9.52357402 L1.79781734,9.52357402 C1.32776747,9.5154301 0.873842794,9.69489943 0.53645143,10.0222834 C0.199060065,10.3496674 0.00600859926,10.7979843 0,11.2680663 L0,23.014822 C0.0486013,23.5994844 0.557330387,24.0369914 1.14268052,23.9975272 L14.8548467,23.9975272 C15.4401968,24.0369914 15.9489259,23.5994844 15.9975272,23.014822 L15.9975272,11.2680663 C15.9915186,10.7979843 15.7984671,10.3496674 15.4610758,10.0222834 C15.1236844,9.69489943 14.6697597,9.5154301 14.1997099,9.52357402 Z M1.52357402,11.2680663 C1.53952384,11.1320038 1.66147877,11.0337624 1.79781734,11.047148 L3.42804155,11.047148 L3.42804155,11.8089351 C3.42804155,12.2296584 3.76910521,12.5707221 4.18982856,12.5707221 C4.6105519,12.5707221 4.95161557,12.2296584 4.95161557,11.8089351 L4.95161557,11.047148 L11.0459116,11.047148 L11.0459116,11.8089351 C11.0459116,12.2296584 11.3869753,12.5707221 11.8076987,12.5707221 C12.228422,12.5707221 12.5694857,12.2296584 12.5694857,11.8089351 L12.5694857,11.047148 L14.1997099,11.047148 C14.3360484,11.0337624 14.4580034,11.1320038 14.4739532,11.2680663 L14.4739532,14.0942961 L1.52357402,14.0942961 L1.52357402,11.2680663 Z" })
          )
        )
      )
    )
  );
};

export var CalendarEmpty = function CalendarEmpty(props) {
  return React.createElement(
    "svg",
    _extends({}, props, {
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      x: "0px",
      y: "0px",
      viewBox: "0 0 16 16",
      xmlSpace: "preserve" }),
    React.createElement(
      "g",
      { stroke: "none", strokeWidth: "1", fillRule: "evenodd" },
      React.createElement(
        "g",
        { transform: "translate(-1272.000000, -216.000000)", fillRule: "nonzero" },
        React.createElement(
          "g",
          { transform: "translate(1240.000000, 0.000000)" },
          React.createElement(
            "g",
            { transform: "translate(16.000000, 88.000000)" },
            React.createElement(
              "g",
              { transform: "translate(16.000000, 64.000000)" },
              React.createElement(
                "g",
                { transform: "translate(0.000000, 56.000000)" },
                React.createElement(
                  "g",
                  { transform: "translate(0.000000, 8.000000)" },
                  React.createElement("path", { d: "M14.5454546,6 L14.5454546,3.2752727 C14.5454546,3.07272724 14.3818182,2.90909088 14.1792727,2.90909088 L12,2.90909088 L12,3.6363636 C12,4.03802524 11.6743889,4.36363632 11.2727273,4.36363632 C10.8710657,4.36363632 10.5454546,4.03802524 10.5454546,3.6363636 L10.5454546,2.90909088 L5.45454555,2.90909088 L5.45454555,3.6363636 C5.45454555,4.03802524 5.12893446,4.36363632 4.72727283,4.36363632 C4.3256112,4.36363632 4.00000011,4.03802524 4.00000011,3.6363636 L4.00000011,2.90909088 L1.8207274,2.90909088 C1.61781831,2.90909088 1.45454559,3.07272724 1.45454559,3.2752727 L1.45454559,6 L14.5454546,6 Z M14.5454546,7.45 L1.45454559,7.45 L1.45454559,14.1792726 C1.45454559,14.3818181 1.61818195,14.5454544 1.8207274,14.5454544 L14.1792727,14.5454544 C14.3821818,14.5454544 14.5454546,14.3818181 14.5454546,14.1792726 L14.5454546,7.45 Z M12,1.45454544 L14.1792727,1.45454544 C14.6621892,1.45444896 15.1253544,1.64624405 15.4668279,1.98771756 C15.8083014,2.32919108 16.0000965,2.79235624 16,3.2752727 L16,14.1792726 C16.000193,14.6622186 15.8084289,15.1254399 15.4669345,15.4669343 C15.12544,15.8084288 14.6622188,16.0001929 14.1792727,15.9999999 L1.8207274,15.9999999 C1.33781094,16.0000963 0.874645781,15.8083012 0.533172269,15.4668277 C0.191698758,15.1253542 -9.63315923e-05,14.6621891 1.45578013e-07,14.1792726 L1.45578013e-07,3.2752727 C-0.000192878442,2.79232666 0.191571207,2.3291054 0.533065654,1.98761095 C0.874560101,1.6461165 1.33778136,1.45435242 1.8207274,1.45454544 L4.00000011,1.45454544 L4.00000011,0.727272721 C4.00000011,0.325611088 4.3256112,0 4.72727283,0 C5.12893446,-8.0743492e-17 5.45454555,0.325611088 5.45454555,0.727272721 L5.45454555,1.45454544 L10.5454546,1.45454544 L10.5454546,0.727272721 C10.5454546,0.325611088 10.8710657,0 11.2727273,0 C11.6743889,-8.0743492e-17 12,0.325611088 12,0.727272721 L12,1.45454544 Z" })
                )
              )
            )
          )
        )
      )
    )
  );
};

export var Link = function Link(props) {
  return React.createElement(
    "svg",
    _extends({}, props, {
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 482.8 482.8",
      xmlSpace: "preserve" }),
    React.createElement(
      "g",
      null,
      React.createElement("path", {
        d: "M255.2,209.3c-5.3,5.3-5.3,13.8,0,19.1c21.9,21.9,21.9,57.5,0,79.4l-115,115c-21.9,21.9-57.5,21.9-79.4,0l-17.3-17.3 c-21.9-21.9-21.9-57.5,0-79.4l115-115c5.3-5.3,5.3-13.8,0-19.1s-13.8-5.3-19.1,0l-115,115C8.7,322.7,0,343.6,0,365.8 c0,22.2,8.6,43.1,24.4,58.8l17.3,17.3c16.2,16.2,37.5,24.3,58.8,24.3s42.6-8.1,58.8-24.3l115-115c32.4-32.4,32.4-85.2,0-117.6 C269.1,204,260.5,204,255.2,209.3z"
      }),
      React.createElement("path", {
        d: "M458.5,58.2l-17.3-17.3c-32.4-32.4-85.2-32.4-117.6,0l-115,115c-32.4,32.4-32.4,85.2,0,117.6c5.3,5.3,13.8,5.3,19.1,0 s5.3-13.8,0-19.1c-21.9-21.9-21.9-57.5,0-79.4l115-115c21.9-21.9,57.5-21.9,79.4,0l17.3,17.3c21.9,21.9,21.9,57.5,0,79.4l-115,115 c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l115-115c15.7-15.7,24.4-36.6,24.4-58.8 C482.8,94.8,474.2,73.9,458.5,58.2z"
      })
    )
  );
};

export var Mail = function Mail(props) {
  return React.createElement(
    "svg",
    _extends({}, props, {
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 16 12",
      xmlSpace: "preserve" }),
    React.createElement(
      "g",
      { stroke: "none", strokeWidth: "1", fillRule: "evenodd" },
      React.createElement(
        "g",
        { transform: "translate(-888.000000, -426.000000)", fillRule: "nonzero" },
        React.createElement(
          "g",
          { transform: "translate(840.000000, 0.000000)" },
          React.createElement(
            "g",
            { transform: "translate(48.000000, 360.000000)" },
            React.createElement(
              "g",
              { transform: "translate(0.000000, 64.000000)" },
              React.createElement(
                "g",
                { itransform: "translate(0.000000, 8.000000)" },
                React.createElement("path", { d: "M0,3.87350127 C0.00038544801,3.37602532 0.192463033,2.89909914 0.533947111,2.54771745 C0.875431189,2.19633576 1.33832652,1.99930522 1.82072727,2.00000184 L14.1792727,2.00000184 C15.1836364,2.00000184 16,2.84075158 16,3.87350127 L16,12.1264987 C15.9996146,12.6239747 15.807537,13.1009009 15.4660529,13.4522825 C15.1245688,13.8036642 14.6616735,14.0006948 14.1792727,13.9999982 L1.82072727,13.9999982 C0.816363636,13.9999982 0,13.1592484 0,12.1264987 L0,3.87350127 Z M14.5454545,6.6991254 L8.37454545,10.5181242 C8.14404909,10.660934 7.85595091,10.660934 7.62545455,10.5181242 L1.45454545,6.6987504 L1.45454545,12.1261237 C1.45454545,12.3297487 1.61927273,12.4996236 1.82072727,12.4996236 L14.1792727,12.4996236 C14.2758411,12.500322 14.3687127,12.4613789 14.4374066,12.3913825 C14.5061005,12.3213862 14.5449741,12.226086 14.5454545,12.1264987 L14.5454545,6.6987504 L14.5454545,6.6991254 Z M13.9625455,5.31050083 C14.2618182,5.12525088 14.5454545,4.60925104 14.5454545,4.25262615 L14.5454545,3.87387627 C14.5454554,3.66782941 14.3838022,3.50062138 14.184,3.50000138 L1.816,3.50000138 C1.61619783,3.50062138 1.45454455,3.66782941 1.45454545,3.87387627 L1.45454545,4.25262615 C1.45454545,4.60737604 1.74,5.12637588 2.03745455,5.31012583 L8,9.00049969 L13.9625455,5.31050083 Z" })
              )
            )
          )
        )
      )
    )
  );
};

export var Comment = function Comment(props) {
  return React.createElement(
    "svg",
    _extends({}, props, {
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 16 16",
      xmlSpace: "preserve" }),
    React.createElement(
      "g",
      null,
      React.createElement(
        "g",
        null,
        React.createElement("path", {
          d: "M-0.75,6.85106383 C-0.75,2.65387154 2.65387154,-0.75 6.85106383,-0.75 C8.20356926,-0.75 9.52561207,-0.387911841 10.7203025,0.309031251 C14.3303214,2.46179485 15.537045,7.1250656 13.3930964,10.7203025 C11.2959007,14.2371384 6.81612923,15.473147 3.2623029,13.5524363 L0.19244833,14.3674419 C-0.364090939,14.5151957 -0.872642497,14.0066441 -0.724888709,13.4501049 L0.092261443,10.3721726 C-0.462263722,9.29638721 -0.75,8.0831457 -0.75,6.85106383 Z M1.05645631,12.5860969 L3.17350912,12.0240475 C3.36873215,11.9722183 3.57660801,12.0013235 3.7500897,12.1047759 C6.63059415,13.8225079 10.3744206,12.8537107 12.1047759,9.95203796 C13.8225079,7.07153351 12.8537107,3.32770706 9.95826694,1.60102567 C8.99775569,1.04072743 7.93626251,0.75 6.85106383,0.75 C3.48229867,0.75 0.75,3.48229867 0.75,6.85106383 C0.75,7.9324152 1.02349526,8.99220933 1.54479938,9.90449154 C1.64261728,10.0756729 1.6690961,10.278487 1.61850573,10.4690441 L1.05645631,12.5860969 Z M9.07978723,6.55319149 C9.07978723,6.13897793 9.41557367,5.80319149 9.82978723,5.80319149 C10.2440008,5.80319149 10.5797872,6.13897793 10.5797872,6.55319149 C10.5797872,8.60570292 8.90357526,10.2819149 6.85106383,10.2819149 C4.7985524,10.2819149 3.12234043,8.60570292 3.12234043,6.55319149 C3.12234043,6.13897793 3.45812686,5.80319149 3.87234043,5.80319149 C4.28655399,5.80319149 4.62234043,6.13897793 4.62234043,6.55319149 C4.62234043,7.7772758 5.62697952,8.78191489 6.85106383,8.78191489 C8.07514814,8.78191489 9.07978723,7.7772758 9.07978723,6.55319149 Z",
          transform: "translate(1 1)"
        })
      )
    )
  );
};

export var Deadline = function Deadline(props) {
  return React.createElement(
    "svg",
    _extends({}, props, {
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 16 16",
      xmlSpace: "preserve" }),
    React.createElement(
      "g",
      { stroke: "none", strokeWidth: "1", fillRule: "evenodd" },
      React.createElement(
        "g",
        { transform: "translate(-888.000000, -1053.000000)", fill: "#ADB5BD", fillRule: "nonzero" },
        React.createElement(
          "g",
          { transform: "translate(840.000000, 0.000000)" },
          React.createElement(
            "g",
            { transform: "translate(0.000000, 1025.000000)" },
            React.createElement(
              "g",
              { transform: "translate(48.000000, 28.000000)" },
              React.createElement(
                "g",
                null,
                React.createElement("path", {
                  d: "M9.46833596,3.33794423 C8.79079385,3.06162133 8.04947042,2.90935149 7.2725825,2.90935149 C4.05935338,2.90935149 1.4545165,5.51418837 1.4545165,8.7274175 C1.4545165,11.9406466 4.05935338,14.5454835 7.2725825,14.5454835 C10.4858116,14.5454835 13.0906485,11.9406466 13.0906485,8.7274175 C13.0906485,7.95052958 12.9383787,7.20920615 12.6620558,6.53166404 C12.5658789,6.55080122 12.4656359,6.55053668 12.3673136,6.52940198 L10.8296272,6.19887128 L10.8294193,6.19907921 C11.3373809,6.91238781 11.636132,7.78501411 11.636132,8.7274175 C11.636132,11.1373393 9.68250435,13.090967 7.2725825,13.090967 C4.86266066,13.090967 2.909033,11.1373393 2.909033,8.7274175 C2.909033,6.31749565 4.86266066,4.36386799 7.2725825,4.36386799 C8.21498589,4.36386799 9.08761219,4.6626191 9.80092079,5.17058073 L9.80112872,5.17037277 L9.47059802,3.63268644 C9.44946332,3.5343641 9.44919878,3.43412112 9.46833596,3.33794423 Z M10.3513241,2.13674353 L11.9065894,0.263077477 C12.2772736,-0.183494938 12.9960008,-0.0372966778 13.16277,0.51860062 L13.6978383,2.30216167 L15.4813994,2.83722999 C16.0372967,3.00399917 16.1834949,3.72272636 15.7369225,4.09341065 L13.8632565,5.64867594 C14.3007545,6.58362272 14.545165,7.62697755 14.545165,8.7274175 C14.545165,12.7439539 11.2891189,16 7.2725825,16 C3.25604609,16 0,12.7439539 0,8.7274175 C0,4.71088108 3.25604609,1.45483499 7.2725825,1.45483499 C8.37302245,1.45483499 9.41637728,1.69924547 10.3513241,2.13674353 Z M8.75034752,6.221154 C8.3172556,5.96523932 7.81206893,5.81838449 7.2725825,5.81838449 C5.66596794,5.81838449 4.3635495,7.12080293 4.3635495,8.7274175 C4.3635495,10.3340321 5.66596794,11.6364505 7.2725825,11.6364505 C8.87919707,11.6364505 10.1816155,10.3340321 10.1816155,8.7274175 C10.1816155,8.18793107 10.0347607,7.6827444 9.778846,7.24965248 L8.67783217,8.3506663 C8.7099668,8.47082875 8.72709901,8.59712238 8.72709901,8.7274175 C8.72709901,9.53072478 8.07588979,10.181934 7.2725825,10.181934 C6.46927522,10.181934 5.818066,9.53072478 5.818066,8.7274175 C5.818066,7.92411021 6.46927522,7.27290099 7.2725825,7.27290099 C7.40287762,7.27290099 7.52917125,7.2900332 7.6493337,7.32216783 L8.75034752,6.221154 Z M12.9048008,3.58281019 C12.6706383,3.51256148 12.4874385,3.32936171 12.4171898,3.09519925 L12.1593826,2.23584194 L10.9668891,3.6724679 L11.2076183,4.79238172 L12.3275321,5.03311085 L13.764158,3.84061739 L12.9048008,3.58281019 Z",
                  id: "ico/deadline-copy"
                })
              )
            )
          )
        )
      )
    )
  );
};

export var Refresh = function Refresh(props) {
  return React.createElement(
    "svg",
    _extends({}, props, {
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 492.883 492.883",
      xmlSpace: "preserve" }),
    React.createElement(
      "g",
      null,
      React.createElement("path", {
        d: "M122.941,374.241c-20.1-18.1-34.6-39.8-44.1-63.1c-25.2-61.8-13.4-135.3,35.8-186l45.4,45.4c2.5,2.5,7,0.7,7.6-3 l24.8-162.3c0.4-2.7-1.9-5-4.6-4.6l-162.4,24.8c-3.7,0.6-5.5,5.1-3,7.6l45.5,45.5c-75.1,76.8-87.9,192-38.6,282 c14.8,27.1,35.3,51.9,61.4,72.7c44.4,35.3,99,52.2,153.2,51.1l10.2-66.7C207.441,421.641,159.441,407.241,122.941,374.241z"
      }),
      React.createElement("path", {
        d: "M424.941,414.341c75.1-76.8,87.9-192,38.6-282c-14.8-27.1-35.3-51.9-61.4-72.7c-44.4-35.3-99-52.2-153.2-51.1l-10.2,66.7 c46.6-4,94.7,10.4,131.2,43.4c20.1,18.1,34.6,39.8,44.1,63.1c25.2,61.8,13.4,135.3-35.8,186l-45.4-45.4c-2.5-2.5-7-0.7-7.6,3 l-24.8,162.3c-0.4,2.7,1.9,5,4.6,4.6l162.4-24.8c3.7-0.6,5.4-5.1,3-7.6L424.941,414.341z"
      })
    )
  );
};

export var User = function User(props) {
  return React.createElement(
    "svg",
    _extends({}, props, {
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 16 16",
      xmlSpace: "preserve" }),
    React.createElement(
      "g",
      { stroke: "none", strokeWidth: "1", fillRule: "evenodd" },
      React.createElement(
        "g",
        { transform: "translate(-888.000000, -124.000000)", fillRule: "nonzero" },
        React.createElement(
          "g",
          { transform: "translate(840.000000, 0.000000)" },
          React.createElement(
            "g",
            { transform: "translate(48.000000, 116.000000)" },
            React.createElement(
              "g",
              { transform: "translate(0.000000, 8.000000)" },
              React.createElement("path", {
                d: "M8,8 C5.79090909,8 4,6.20909091 4,4 C4,1.79090909 5.79090909,0 8,0 C10.2090909,0 12,1.79090909 12,4 C12,6.20909091 10.2090909,8 8,8 Z M8,6.54545455 C8.90940333,6.54545456 9.74972667,6.06029367 10.2044283,5.27272729 C10.65913,4.4851609 10.65913,3.5148391 10.2044283,2.72727271 C9.74972667,1.93970633 8.90940333,1.45454544 8,1.45454545 C6.59418429,1.45454548 5.45454551,2.59418429 5.45454551,4 C5.45454551,5.40581571 6.59418429,6.54545452 8,6.54545455 Z M15.5698182,11.696 C15.6970909,11.9730909 15.7865455,12.3723636 15.8643636,12.9025455 C15.9182894,13.2740579 15.9601297,13.6472245 15.9898182,14.0214545 L15.9981818,14.1301818 L16,14.1818182 C16.0000007,15.1851208 15.1873019,15.998796 14.184,16 L1.816,16 C0.812698068,15.998796 -7.2237817e-07,15.1851208 0,14.1818182 L0.00181818182,14.1301818 L0.0101818182,14.0214545 C0.0412499976,13.6473578 0.0830855216,13.2742335 0.135636364,12.9025455 C0.213454545,12.3723636 0.302909091,11.9730909 0.430181818,11.696 C0.989090909,10.4825455 5.10363636,8.72727273 8,8.72727273 C10.8963636,8.72727273 15.0109091,10.4825455 15.5698182,11.696 Z M14.1745455,12.2501818 C14.0727273,12.1610909 13.9272727,12.0541818 13.7472727,11.9385455 C13.3443636,11.6792727 12.812,11.4021818 12.224,11.1512727 C10.8145455,10.5498182 9.30290909,10.1818182 8,10.1818182 C6.69709091,10.1818182 5.18581818,10.5498182 3.776,11.1512727 C3.188,11.4021818 2.65563636,11.6792727 2.25272727,11.9385455 C2.07309091,12.0541818 1.92727273,12.1610909 1.82545455,12.2501818 C1.78763636,12.2836364 1.75854545,12.312 1.73927273,12.3334545 C1.69018182,12.4621818 1.62836364,12.7483636 1.57490909,13.1138182 C1.53890909,13.3574545 1.50836364,13.6207273 1.48290909,13.8847273 C1.46981818,14.0207273 1.46036364,14.1305455 1.45490909,14.2014545 C1.46529709,14.393599 1.62357793,14.5443882 1.816,14.5454545 L14.184,14.5454545 C14.3764221,14.5443882 14.5347029,14.393599 14.5450909,14.2014545 C14.5396364,14.1305455 14.5305455,14.0207273 14.5170909,13.8850909 C14.4927014,13.62729 14.4620256,13.3701226 14.4250909,13.1138182 C14.3716364,12.7483636 14.3098182,12.4621818 14.2607273,12.3334545 C14.2336349,12.3040533 14.2048593,12.276249 14.1745455,12.2501818 Z",
                id: "Shape"
              })
            )
          )
        )
      )
    )
  );
};

export var Team = function Team(props) {
  return React.createElement(
    "svg",
    _extends({}, props, {
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 24 20",
      xmlSpace: "preserve" }),
    React.createElement(
      "g",
      { stroke: "none", strokeWidth: "1", fillRule: "evenodd" },
      React.createElement(
        "g",
        { transform: "translate(-28.000000, -222.000000)", fillRule: "nonzero" },
        React.createElement(
          "g",
          { id: "team", transform: "translate(0.000000, 192.000000)" },
          React.createElement("path", {
            d: "M39,35 C39,32.23855 41.2386,30 44,30 C46.7614,30 49,32.23855 49,35 C49,37.76145 46.7614,40 44,40 C41.2386,40 39,37.76145 39,35 Z M30.4,37.2 C30.4,34.99085 32.19085,33.2 34.4,33.2 C36.60915,33.2 38.4,34.99085 38.4,37.2 C38.4,39.40915 36.60915,41.2 34.4,41.2 C32.19085,41.2 30.4,39.40915 30.4,37.2 Z M52,44.5 L52,47 C52,48.6568542 50.6568542,50 49,50 L39,50 C37.3431458,50 36,48.6568542 36,47 L36,44.5 C36,42.567 37.567,41 39.5,41 L40.3924,41 C42.6106,42.33435 45.3889,42.33465 47.60765,41 L48.5,41 C50.433,41 52,42.567 52,44.5 Z M34.4,44.5 C34.4,43.90125 34.50405,43.3264 34.69445,42.7922 C33.59795,42.8498 32.48835,42.58615 31.5139,42 L30.8,42 C29.2536,42 28,43.2536 28,44.8 L28,44.8 C28,46.3463973 29.2536027,47.6 30.8,47.6 L34.4,47.6 L34.4,44.5 Z",
            id: "Shape"
          })
        )
      )
    )
  );
};

export var List = function List(props) {
  return React.createElement(
    "svg",
    _extends({}, props, {
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 16 16",
      xmlSpace: "preserve" }),
    React.createElement(
      "g",
      { stroke: "none", strokeWidth: "1", fillRule: "evenodd" },
      React.createElement(
        "g",
        { transform: "translate(-888.000000, -884.000000)", fillRule: "nonzero" },
        React.createElement(
          "g",
          { transform: "translate(840.000000, 0.000000)" },
          React.createElement(
            "g",
            { transform: "translate(0.000000, 856.000000)" },
            React.createElement(
              "g",
              { transform: "translate(48.000000, 28.000000)" },
              React.createElement("path", { d: "M6.10574713,2.02298851 C6.10574713,1.50804598 6.51034483,1.10344828 7.02528736,1.10344828 L15.0804598,1.10344828 C15.5954023,1.10344828 16,1.50804598 16,2.02298851 C16,2.53793103 15.5954023,2.94252874 15.0804598,2.94252874 L7.02528736,2.94252874 C6.52873563,2.94252874 6.10574713,2.53793103 6.10574713,2.02298851 Z M15.0804598,6.98850575 L7.02528736,6.98850575 C6.51034483,6.98850575 6.10574713,7.39310345 6.10574713,7.90804598 C6.10574713,8.42298851 6.51034483,8.82758621 7.02528736,8.82758621 L15.0804598,8.82758621 C15.5954023,8.82758621 16,8.42298851 16,7.90804598 C16,7.39310345 15.5954023,6.98850575 15.0804598,6.98850575 Z M15.0804598,12.8735632 L7.02528736,12.8735632 C6.51034483,12.8735632 6.10574713,13.2781609 6.10574713,13.7931034 C6.10574713,14.308046 6.51034483,14.7126437 7.02528736,14.7126437 L15.0804598,14.7126437 C15.5954023,14.7126437 16,14.308046 16,13.7931034 C16,13.2781609 15.5954023,12.8735632 15.0804598,12.8735632 Z M4.04597701,0.643678161 L4.04597701,3.40229885 C4.04597701,3.75172414 3.75172414,4.04597701 3.40229885,4.04597701 L0.643678161,4.04597701 C0.294252874,4.04597701 0,3.75172414 0,3.40229885 L0,0.643678161 C0,0.294252874 0.294252874,0 0.643678161,0 L3.40229885,0 C3.75172414,0 4.04597701,0.294252874 4.04597701,0.643678161 Z M2.94252874,1.17241379 L1.28735632,1.17241379 L1.28735632,2.64367816 L2.94252874,2.64367816 L2.94252874,1.17241379 Z M4.04597701,9.28735632 C4.04597701,9.63678161 3.75172414,9.93103448 3.40229885,9.93103448 L0.643678161,9.93103448 C0.294252874,9.93103448 0,9.63678161 0,9.28735632 L0,6.52873563 C0,6.17931034 0.294252874,5.88505747 0.643678161,5.88505747 L3.40229885,5.88505747 C3.75172414,5.88505747 4.04597701,6.17931034 4.04597701,6.52873563 L4.04597701,9.28735632 Z M2.94252874,7.17241379 L1.28735632,7.17241379 L1.28735632,8.64367816 L2.94252874,8.64367816 L2.94252874,7.17241379 Z M4.04597701,15.1724138 C4.04597701,15.5218391 3.75172414,15.816092 3.40229885,15.816092 L0.643678161,15.816092 C0.294252874,15.816092 0,15.5218391 0,15.1724138 L0,12.4137931 C0,12.0643678 0.294252874,11.7701149 0.643678161,11.7701149 L3.40229885,11.7701149 C3.75172414,11.7701149 4.04597701,12.0643678 4.04597701,12.4137931 L4.04597701,15.1724138 Z M2.94252874,13.0574713 L1.28735632,13.0574713 L1.28735632,14.7126437 L2.94252874,14.7126437 L2.94252874,13.0574713 Z" })
            )
          )
        )
      )
    )
  );
};

export var Tag = function Tag(props) {
  return React.createElement(
    "svg",
    _extends({}, props, {
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 16 16",
      xmlSpace: "preserve" }),
    React.createElement(
      "g",
      { stroke: "none", strokeWidth: "1", fillRule: "evenodd" },
      React.createElement(
        "g",
        { transform: "translate(-936.000000, -884.000000)", fillRule: "nonzero" },
        React.createElement(
          "g",
          { transform: "translate(840.000000, 0.000000)" },
          React.createElement(
            "g",
            { transform: "translate(0.000000, 856.000000)" },
            React.createElement(
              "g",
              { transform: "translate(96.000000, 28.000000)" },
              React.createElement("path", { d: "M6.08997915,15.4200207 L0.578979152,9.90902071 C-0.198020848,9.13402071 -0.190020848,7.86702071 0.581979152,7.09402071 L6.65197915,1.02402071 C7.22497915,0.45202071 8.24697915,0.0280207103 9.05197915,0.0240207103 L14.0079792,2.07103059e-05 C15.1099792,-0.00497928969 16.0049792,0.89602071 15.9999792,1.99302071 L15.9759792,6.94602071 C15.9719792,7.75602071 15.5439792,8.77602071 14.9739792,9.34602071 L8.90397915,15.4160207 C8.12697915,16.1930207 6.86597915,16.1950207 6.08997915,15.4200207 Z M1.65239551,8.83283424 L7.16408826,14.3445257 C7.34575355,14.5259568 7.64487884,14.5255164 7.82917684,14.3412184 L13.8991768,8.2712184 C14.1875913,7.98280391 14.4539869,7.34568995 14.4559977,6.93851463 L14.479997,1.98565556 C14.4811565,1.73123587 14.2692851,1.51885076 14.0148756,1.52000507 L9.05933984,1.54400289 C8.6527911,1.54602302 8.01445146,1.81165588 7.72584236,2.0997613 L1.65678146,8.16882302 C1.47490486,8.35093566 1.47408552,8.65498322 1.65239551,8.83283424 Z M10.9999792,7.00002071 C9.89497915,7.00002071 8.99997915,6.10502071 8.99997915,5.00002071 C8.99997915,3.89502071 9.89497915,3.00002071 10.9999792,3.00002071 C12.1049792,3.00002071 12.9999792,3.89502071 12.9999792,5.00002071 C12.9999792,6.10502071 12.1049792,7.00002071 10.9999792,7.00002071 Z" })
            )
          )
        )
      )
    )
  );
};

export var Trash = function Trash(props) {
  return React.createElement(
    "svg",
    _extends({}, props, { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }),
    React.createElement(
      "g",
      { stroke: "none", strokeWidth: "1", fillRule: "evenodd" },
      React.createElement(
        "g",
        { transform: "translate(-1320.000000, -884.000000)", fillRule: "nonzero" },
        React.createElement(
          "g",
          { transform: "translate(840.000000, 0.000000)" },
          React.createElement(
            "g",
            { transform: "translate(0.000000, 856.000000)" },
            React.createElement(
              "g",
              { transform: "translate(480.000000, 28.000000)" },
              React.createElement("path", { d: "M14.3472,5.79054564 L13.6836,14.2349093 C13.6064,15.2167275 12.6836,16.0000002 11.6036,16.0000002 L4.396,16.0000002 C3.314,16.0000002 2.3932,15.2192729 2.316,14.2349093 L1.6528,5.79054564 C0.697617568,5.63627656 0.00131546327,4.88194417 0,4.00000019 L0,3.27272746 C0.000688453151,2.28754014 0.863888325,1.48185683 1.9472,1.45527292 L4.5348,1.16072746 C4.8338045,0.46072554 5.57518135,-0.000341935914 6.4012,1.90271296e-07 L9.5988,1.90271296e-07 C10.424563,0.000481978295 11.1654219,0.461470495 11.4648,1.1610911 L14.0528,1.45527292 C15.1357471,1.48261324 15.9984702,2.28785153 16,3.27272746 L16,4.00000019 C15.999496,4.88221309 15.3028146,5.63695641 14.3472,5.79054564 Z M3.2592,5.81818201 L3.9124,14.1312729 C3.93,14.3552729 4.1544,14.5454547 4.3964,14.5454547 L11.604,14.5454547 C11.844,14.5454547 12.0708,14.3527275 12.088,14.1312729 L12.7408,5.81818201 L3.2592,5.81818201 Z M9.2028,7.93963655 C9.2238305,7.6787846 9.39731773,7.44828861 9.65715197,7.33598229 C9.91698621,7.22367597 10.2231445,7.24685814 10.458961,7.39669492 C10.6947775,7.5465317 10.8239288,7.79994334 10.7972,8.06036383 L10.3972,12.4240002 C10.3761695,12.6848521 10.2026823,12.9153481 9.94284803,13.0276545 C9.68301379,13.1399608 9.37685548,13.1167786 9.14103897,12.9669418 C8.90522246,12.817105 8.77607117,12.5636934 8.8028,12.3032729 L9.2028,7.93963655 Z M5.2028,8.06036383 C5.17607117,7.79994334 5.30522246,7.5465317 5.54103897,7.39669492 C5.77685548,7.24685814 6.08301379,7.22367597 6.34284803,7.33598229 C6.60268227,7.44828861 6.7761695,7.6787846 6.7972,7.93963655 L7.1972,12.3032729 C7.22392883,12.5636934 7.09477754,12.817105 6.85896103,12.9669418 C6.62314452,13.1167786 6.31698621,13.1399608 6.05715197,13.0276545 C5.79731773,12.9153481 5.6238305,12.6848521 5.6028,12.4240002 L5.2028,8.06036383 Z M2.0028,2.9090911 C1.78,2.9090911 1.6,3.07236383 1.6,3.27272746 L1.6,4.00000019 C1.6,4.19927292 1.7808,4.36363655 2.0028,4.36363655 L13.9972,4.36363655 C14.22,4.36363655 14.4,4.20036383 14.4,4.00000019 L14.4,3.27272746 C14.4,3.07345474 14.2192,2.9090911 13.9972,2.9090911 C13.9639075,2.90915875 13.9306428,2.90733702 13.8976,2.90363655 L10.7008,2.54000019 C10.3003787,2.49451072 9.99991212,2.18503262 10,1.81818201 C10,1.61854564 9.8196,1.45454564 9.5988,1.45454564 L6.4012,1.45454564 C6.29490564,1.45425575 6.19285552,1.49243931 6.11758123,1.56066581 C6.04230694,1.6288923 5.99999952,1.72155034 6,1.81818201 C6.00008788,2.18503262 5.69962128,2.49451072 5.2992,2.54000019 L2.1024,2.90363655 C2.06935719,2.90733702 2.0360925,2.90915875 2.0028,2.9090911 Z" })
            )
          )
        )
      )
    )
  );
};

export var Stopwatch = function Stopwatch(props) {
  return React.createElement(
    "svg",
    _extends({}, props, {
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 16 16",
      xmlSpace: "preserve" }),
    React.createElement(
      "g",
      { stroke: "none", strokeWidth: "1", fillRule: "evenodd" },
      React.createElement(
        "g",
        { transform: "translate(-468.000000, -336.000000)", fill: "#ADABBC", fillRule: "nonzero" },
        React.createElement(
          "g",
          { transform: "translate(420.000000, 160.000000)" },
          React.createElement(
            "g",
            { transform: "translate(48.000000, 168.000000)" },
            React.createElement(
              "g",
              { id: "estimate" },
              React.createElement(
                "g",
                { transform: "translate(0.000000, 8.000000)" },
                React.createElement("path", { d: "M8.00000001,16 C4.0025104,16 0.761904763,12.9066946 0.761904763,9.09090909 C0.761904763,5.27512356 4.0025104,2.18181818 8.00000001,2.18181818 C11.9974896,2.18181818 15.2380952,5.27512356 15.2380952,9.09090909 C15.2380952,10.8918063 14.5121655,12.5856644 13.2351364,13.8620636 C11.8785327,15.2179983 10.0036838,16 8.00000001,16 Z M8.00000001,14.5454545 C9.58303463,14.5454545 11.0611605,13.9289264 12.1331396,12.857476 C13.1420626,11.8490507 13.7142857,10.5138461 13.7142857,9.09090909 C13.7142857,6.07844684 11.1559128,3.63636364 8.00000001,3.63636364 C4.84408717,3.63636364 2.28571429,6.07844684 2.28571429,9.09090909 C2.28571429,12.1033713 4.84408717,14.5454545 8.00000001,14.5454545 Z M15.7768433,3.48574051 C16.0743856,3.76975818 16.0743856,4.23024182 15.7768433,4.51425949 C15.479301,4.79827713 14.9968895,4.79827713 14.6993472,4.51425949 L13.1755377,3.05971404 C12.8779954,2.77569636 12.8779954,2.31521273 13.1755377,2.03119507 C13.47308,1.7471774 13.9554914,1.7471774 14.2530338,2.03119507 L15.7768433,3.48574051 Z M1.30065279,4.51425949 C1.00311047,4.79827713 0.520699056,4.79827713 0.22315674,4.51425949 C-0.07438558,4.23024182 -0.07438558,3.76975818 0.22315674,3.48574051 L1.74696626,2.03119507 C2.04450858,1.7471774 2.52691999,1.7471774 2.82446233,2.03119507 C3.12200461,2.31521273 3.12200461,2.77569636 2.82446233,3.05971404 L1.30065279,4.51425949 Z M8.76190477,9.09090909 C8.76190477,9.49257073 8.42078839,9.81818182 8.00000001,9.81818182 C7.57921162,9.81818182 7.23809524,9.49257073 7.23809524,9.09090909 L7.23809524,5.45454545 C7.23809524,5.05288382 7.57921162,4.72727273 8.00000001,4.72727273 C8.42078839,4.72727273 8.76190477,5.05288382 8.76190477,5.45454545 L8.76190477,9.09090909 Z M6.0952381,1.52 C5.67444972,1.52 5.33333334,1.17973641 5.33333334,0.76 C5.33333334,0.34026359 5.67444972,0 6.0952381,0 L9.90476191,0 C10.3255503,0 10.6666667,0.34026359 10.6666667,0.76 C10.6666667,1.17973641 10.3255503,1.52 9.90476191,1.52 L6.0952381,1.52 Z" })
              )
            )
          )
        )
      )
    )
  );
};

export var Clock = function Clock(props) {
  return React.createElement(
    "svg",
    _extends({}, props, {
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 512 512",
      xmlSpace: "preserve" }),
    React.createElement(
      "g",
      { stroke: "none", strokeWidth: "1", fillRule: "evenodd" },
      React.createElement(
        "g",
        { transform: "translate(-468.000000, -336.000000)", fill: "#ADABBC", fillRule: "nonzero" },
        React.createElement(
          "g",
          { transform: "translate(420.000000, 160.000000)" },
          React.createElement(
            "g",
            { transform: "translate(48.000000, 168.000000)" },
            React.createElement(
              "g",
              { id: "estimate" },
              React.createElement(
                "g",
                { transform: "translate(0.000000, 8.000000)" },
                React.createElement("path", {
                  fill: "currentColor",
                  d: "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z"
                })
              )
            )
          )
        )
      )
    )
  );
};

export var Bell = function Bell(props) {
  return React.createElement(
    "svg",
    _extends({}, props, {
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 459.334 459.334",
      xmlSpace: "preserve" }),
    React.createElement(
      "g",
      null,
      React.createElement("path", {
        d: "M175.216,404.514c-0.001,0.12-0.009,0.239-0.009,0.359c0,30.078,24.383,54.461,54.461,54.461 s54.461-24.383,54.461-54.461c0-0.12-0.008-0.239-0.009-0.359H175.216z"
      }),
      React.createElement("path", {
        d: "M403.549,336.438l-49.015-72.002c0-22.041,0-75.898,0-89.83c0-60.581-43.144-111.079-100.381-122.459V24.485 C254.152,10.963,243.19,0,229.667,0s-24.485,10.963-24.485,24.485v27.663c-57.237,11.381-100.381,61.879-100.381,122.459 c0,23.716,0,76.084,0,89.83l-49.015,72.002c-5.163,7.584-5.709,17.401-1.419,25.511c4.29,8.11,12.712,13.182,21.887,13.182 H383.08c9.175,0,17.597-5.073,21.887-13.182C409.258,353.839,408.711,344.022,403.549,336.438z"
      })
    )
  );
};

export var Pin = function Pin(props) {
  return React.createElement(
    "svg",
    _extends({}, props, {
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 16 16",
      xmlSpace: "preserve" }),
    React.createElement(
      "g",
      { stroke: "none", strokeWidth: "1", fillRule: "evenodd" },
      React.createElement(
        "g",
        {
          id: "01_04_02\u2013\u2013GipsyBot\u2013email",
          transform: "translate(-1272.000000, -368.000000)",
          fill: "#ADABBC",
          fillRule: "nonzero" },
        React.createElement(
          "g",
          { id: "BOX", transform: "translate(1240.000000, 0.000000)" },
          React.createElement(
            "g",
            { id: "PICKER", transform: "translate(0.000000, 248.000000)" },
            React.createElement(
              "g",
              { id: "hour", transform: "translate(32.000000, 112.000000)" },
              React.createElement(
                "g",
                { id: "Icons/Task/Pin", transform: "translate(0.000000, 8.000000)" },
                React.createElement("path", { d: "M15.6838786,5.39004495 L10.6473891,0.342418606 C10.2513376,-0.087092771 9.58340749,-0.116485274 9.15123931,0.276580002 C8.75939213,0.705552037 8.78378981,1.36991342 9.20604333,1.7689217 L9.59515188,2.15846678 L6.94811767,4.81944371 C5.33901741,4.48111457 3.66320174,4.88392267 2.38294271,5.91675378 C2.27300098,6.00688227 2.20615284,6.13927115 2.19884858,6.28134153 C2.19154433,6.42341191 2.2444622,6.56197213 2.3445799,6.66292463 L9.33209258,13.6966822 C9.43293196,13.7969122 9.57133691,13.8498895 9.71324808,13.842577 C9.85515925,13.8352646 9.98739978,13.7683414 10.0774273,13.6582764 C11.109101,12.376581 11.5114577,10.6988853 11.1735077,9.0879799 L13.8205419,6.43797607 L14.2096505,6.82752114 C14.6087881,7.25382724 15.2765778,7.27831585 15.7058002,6.88238665 C16.1064436,6.46227579 16.0966884,5.79817984 15.6838786,5.39004495 Z M0.108575838,15.090266 C-0.036191946,15.2444379 -0.036191946,15.4847491 0.108575838,15.638921 L0.360674335,15.8913024 C0.514673511,16.0362325 0.75471537,16.0362325 0.908714546,15.8913024 L5.44100709,12.0836364 L3.9119749,10.5803216 L0.108575838,15.090266 Z" })
              )
            )
          )
        )
      )
    )
  );
};

export var Slack = function Slack(props) {
  return React.createElement(
    "svg",
    _extends({}, props, {
      "aria-hidden": "true",
      focusable: "false",
      "data-prefix": "fab",
      "data-icon": "slack",
      "class": "svg-inline--fa fa-slack fa-w-14",
      role: "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 448 512" }),
    React.createElement("path", {
      fill: "currentColor",
      d: "M94.12 315.1c0 25.9-21.16 47.06-47.06 47.06S0 341 0 315.1c0-25.9 21.16-47.06 47.06-47.06h47.06v47.06zm23.72 0c0-25.9 21.16-47.06 47.06-47.06s47.06 21.16 47.06 47.06v117.84c0 25.9-21.16 47.06-47.06 47.06s-47.06-21.16-47.06-47.06V315.1zm47.06-188.98c-25.9 0-47.06-21.16-47.06-47.06S139 32 164.9 32s47.06 21.16 47.06 47.06v47.06H164.9zm0 23.72c25.9 0 47.06 21.16 47.06 47.06s-21.16 47.06-47.06 47.06H47.06C21.16 243.96 0 222.8 0 196.9s21.16-47.06 47.06-47.06H164.9zm188.98 47.06c0-25.9 21.16-47.06 47.06-47.06 25.9 0 47.06 21.16 47.06 47.06s-21.16 47.06-47.06 47.06h-47.06V196.9zm-23.72 0c0 25.9-21.16 47.06-47.06 47.06-25.9 0-47.06-21.16-47.06-47.06V79.06c0-25.9 21.16-47.06 47.06-47.06 25.9 0 47.06 21.16 47.06 47.06V196.9zM283.1 385.88c25.9 0 47.06 21.16 47.06 47.06 0 25.9-21.16 47.06-47.06 47.06-25.9 0-47.06-21.16-47.06-47.06v-47.06h47.06zm0-23.72c-25.9 0-47.06-21.16-47.06-47.06 0-25.9 21.16-47.06 47.06-47.06h117.84c25.9 0 47.06 21.16 47.06 47.06 0 25.9-21.16 47.06-47.06 47.06H283.1z" })
  );
};

export var DragHandle = function DragHandle(props) {
  return React.createElement(
    "svg",
    _extends({}, props, {
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 512 512",
      xmlSpace: "preserve" }),
    React.createElement("path", { d: "M496 288H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-128H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z" })
  );
};

/* Navigation */

export var Chart = function Chart(props) {
  return React.createElement(
    "svg",
    _extends({}, props, {
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 24 24",
      xmlSpace: "preserve" }),
    React.createElement(
      "g",
      { stroke: "none", strokeWidth: "1", fillRule: "evenodd" },
      React.createElement(
        "g",
        { transform: "translate(-28.000000, -220.000000)" },
        React.createElement(
          "g",
          { transform: "translate(0.000000, 192.000000)" },
          React.createElement("path", {
            d: "M36.7907049,45.0314286 L43.2832103,51.5114286 C44.0956054,51.283584 44.8815042,50.9704047 45.6277262,50.5771429 L38.4395952,43.4285714 L36.7907049,45.0314286 Z M50.4198135,46 C51.2787647,44.5441522 51.8174266,42.9225136 52,41.2428571 L45.6277262,41.2428571 L50.4198135,46 Z M41.3337411,41.2514286 L40.5779997,41.2514286 L39.9510779,41.8771429 L47.4741397,49.3857143 C48.0975202,48.9084319 48.6727746,48.371605 49.1917338,47.7828571 L42.6219366,41.2514286 L41.3337411,41.2514286 Z M38.7573501,28 C34.3739403,28.4632271 30.5959309,31.2833447 28.9120346,35.3490943 C27.2281383,39.4148439 27.9083591,44.0743038 30.6846581,47.4914286 L38.1701997,40.0203052 C38.5461067,39.6451222 38.7573501,39.1358301 38.7573501,38.604729 L38.7573501,28 Z M41.3337411,28 L41.3337411,36.68 C41.3337411,37.7845695 42.2291716,38.68 43.3337411,38.68 L52,38.68 C51.4096057,33.0565219 46.9661442,28.6073359 41.3337411,28 Z M32.5053078,49.3085714 C34.6343085,51.0436111 37.2969821,51.9940315 40.0455456,52 C40.2602448,52 40.4577681,52 40.6724674,52 L35.2706342,46.5485714 L32.5053078,49.3085714 Z",
            id: "icons/nav/reports"
          })
        )
      )
    )
  );
};

export var Folder = function Folder(props) {
  return React.createElement(
    "svg",
    _extends({}, props, {
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 24 24",
      xmlSpace: "preserve" }),
    React.createElement(
      "g",
      { stroke: "none", strokeWidth: "1", fillRule: "evenodd" },
      React.createElement(
        "g",
        { transform: "translate(-28.000000, -316.000000)" },
        React.createElement(
          "g",
          { transform: "translate(0.000000, 288.000000)" },
          React.createElement("path", {
            d: "M52,37.527787 C50.938487,36.5777071 49.5367089,36 48,36 L42,36 C38.6862915,36 36,38.6862915 36,42 L36,46 L32,46 C29.790861,46 28,44.209139 28,42 L28,31 C28,29.3431458 29.3431458,28 31,28 L32.3431458,28 C33.4040117,28 34.4214274,28.4214274 35.1715729,29.1715729 L35.8284271,29.8284271 C36.5785726,30.5785726 37.5959883,31 38.6568542,31 L48,31 C50.209139,31 52,32.790861 52,35 L52,37.527787 Z M43,38 L47,38 C49.7614237,38 52,40.2385763 52,43 L52,47 C52,49.7614237 49.7614237,52 47,52 L43,52 C40.2385763,52 38,49.7614237 38,47 L38,43 C38,40.2385763 40.2385763,38 43,38 Z M44.0048236,45.9074994 L42.6264151,44.4701191 C42.2962449,44.1258234 41.7136999,44.0839574 41.3252644,44.3766087 C40.9368288,44.6692601 40.8895955,45.1856077 41.2197657,45.5299034 L43.3120618,47.7117132 C43.6842341,48.099808 44.3617208,48.0953961 44.7274194,47.7024961 L48.7889355,43.3388764 C49.1133625,42.9903178 49.0575746,42.4746411 48.6643297,42.1870802 C48.2710848,41.8995194 47.6892967,41.9489679 47.3648696,42.2975265 L44.0048236,45.9074994 Z",
            id: "icons/nav/archive"
          })
        )
      )
    )
  );
};

export var Alarm = function Alarm(props) {
  return React.createElement(
    "svg",
    _extends({}, props, {
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 510 510",
      xmlSpace: "preserve" }),
    React.createElement(
      "g",
      null,
      React.createElement("path", {
        d: "M255,510c28.05,0,51-22.95,51-51H204C204,487.05,226.95,510,255,510z M420.75,357V216.75 c0-79.05-53.55-142.8-127.5-160.65V38.25C293.25,17.85,275.4,0,255,0c-20.4,0-38.25,17.85-38.25,38.25V56.1 c-73.95,17.85-127.5,81.6-127.5,160.65V357l-51,51v25.5h433.5V408L420.75,357z"
      })
    )
  );
};

export var Settings = function Settings(props) {
  return React.createElement(
    "svg",
    _extends({}, props, {
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 268.765 268.765",
      xmlSpace: "preserve" }),
    React.createElement(
      "g",
      null,
      React.createElement("path", {
        d: "M267.92,119.461c-0.425-3.778-4.83-6.617-8.639-6.617 c-12.315,0-23.243-7.231-27.826-18.414c-4.682-11.454-1.663-24.812,7.515-33.231c2.889-2.641,3.24-7.062,0.817-10.133 c-6.303-8.004-13.467-15.234-21.289-21.5c-3.063-2.458-7.557-2.116-10.213,0.825c-8.01,8.871-22.398,12.168-33.516,7.529 c-11.57-4.867-18.866-16.591-18.152-29.176c0.235-3.953-2.654-7.39-6.595-7.849c-10.038-1.161-20.164-1.197-30.232-0.08 c-3.896,0.43-6.785,3.786-6.654,7.689c0.438,12.461-6.946,23.98-18.401,28.672c-10.985,4.487-25.272,1.218-33.266-7.574 c-2.642-2.896-7.063-3.252-10.141-0.853c-8.054,6.319-15.379,13.555-21.74,21.493c-2.481,3.086-2.116,7.559,0.802,10.214 c9.353,8.47,12.373,21.944,7.514,33.53c-4.639,11.046-16.109,18.165-29.24,18.165c-4.261-0.137-7.296,2.723-7.762,6.597 c-1.182,10.096-1.196,20.383-0.058,30.561c0.422,3.794,4.961,6.608,8.812,6.608c11.702-0.299,22.937,6.946,27.65,18.415 c4.698,11.454,1.678,24.804-7.514,33.23c-2.875,2.641-3.24,7.055-0.817,10.126c6.244,7.953,13.409,15.19,21.259,21.508 c3.079,2.481,7.559,2.131,10.228-0.81c8.04-8.893,22.427-12.184,33.501-7.536c11.599,4.852,18.895,16.575,18.181,29.167 c-0.233,3.955,2.67,7.398,6.595,7.85c5.135,0.599,10.301,0.898,15.481,0.898c4.917,0,9.835-0.27,14.752-0.817 c3.897-0.43,6.784-3.786,6.653-7.696c-0.451-12.454,6.946-23.973,18.386-28.657c11.059-4.517,25.286-1.211,33.281,7.572 c2.657,2.89,7.047,3.239,10.142,0.848c8.039-6.304,15.349-13.534,21.74-21.494c2.48-3.079,2.13-7.559-0.803-10.213 c-9.353-8.47-12.388-21.946-7.529-33.524c4.568-10.899,15.612-18.217,27.491-18.217l1.662,0.043 c3.853,0.313,7.398-2.655,7.865-6.588C269.044,139.917,269.058,129.639,267.92,119.461z M134.595,179.491 c-24.718,0-44.824-20.106-44.824-44.824c0-24.717,20.106-44.824,44.824-44.824c24.717,0,44.823,20.107,44.823,44.824 C179.418,159.385,159.312,179.491,134.595,179.491z"
      })
    )
  );
};

export var Save = function Save(props) {
  return React.createElement(
    "svg",
    _extends({}, props, {
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 459 459",
      xmlSpace: "preserve" }),
    React.createElement(
      "g",
      null,
      React.createElement("path", {
        d: "M357,0H51C22.95,0,0,22.95,0,51v357c0,28.05,22.95,51,51,51h357c28.05,0,51-22.95,51-51V102L357,0z M229.5,408 c-43.35,0-76.5-33.15-76.5-76.5s33.15-76.5,76.5-76.5c43.35,0,76.5,33.15,76.5,76.5S272.85,408,229.5,408z M306,153H51V51h255V153 z"
      })
    )
  );
};

export var Watcher = function Watcher(props) {
  return React.createElement(
    "svg",
    _extends({}, props, {
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 16 16",
      xmlSpace: "preserve" }),
    React.createElement(
      "g",
      null,
      React.createElement("path", { d: "M6,0 L10,0 C13.3137085,-6.08718376e-16 16,2.6862915 16,6 L16,10 C16,13.3137085 13.3137085,16 10,16 L6,16 C2.6862915,16 4.05812251e-16,13.3137085 0,10 L0,6 C-4.05812251e-16,2.6862915 2.6862915,6.08718376e-16 6,0 Z M6,1.52 C3.52576432,1.52 1.52,3.52576432 1.52,6 L1.52,10 C1.52,12.4742357 3.52576432,14.48 6,14.48 L10,14.48 C12.4742357,14.48 14.48,12.4742357 14.48,10 L14.48,6 C14.48,3.52576432 12.4742357,1.52 10,1.52 L6,1.52 Z M10.3159354,8 C10.5596151,8 10.7886152,7.94029364 10.9911923,7.83752039 C10.9951069,7.89233279 11,7.9451876 11,8 C11,9.65709628 9.65731528,11 8.00048931,11 C6.34366335,11 5,9.65709628 5,8 C5,6.34290376 6.34366335,5 8.00048931,5 C8.4956777,5 8.96052846,5.1223491 9.37253303,5.33376835 C9.03294732,5.60978793 8.81666938,6.02871126 8.81666938,6.4995106 C8.81666938,7.32756933 9.48703311,8 10.3159354,8 Z" })
    )
  );
};

export var Bullseye = function Bullseye(props) {
  return React.createElement(
    "svg",
    _extends({}, props, {
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 496 512",
      xmlSpace: "preserve" }),
    React.createElement(
      "g",
      null,
      React.createElement("path", {
        fill: "currentColor",
        d: "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 432c-101.69 0-184-82.29-184-184 0-101.69 82.29-184 184-184 101.69 0 184 82.29 184 184 0 101.69-82.29 184-184 184zm0-312c-70.69 0-128 57.31-128 128s57.31 128 128 128 128-57.31 128-128-57.31-128-128-128zm0 192c-35.29 0-64-28.71-64-64s28.71-64 64-64 64 28.71 64 64-28.71 64-64 64z"
      })
    )
  );
};

export var Star = function Star(props) {
  return React.createElement(
    "svg",
    _extends({}, props, {
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 49.94 49.94",
      xmlSpace: "preserve" }),
    React.createElement(
      "g",
      null,
      React.createElement("path", {
        d: "M48.856,22.73c0.983-0.958,1.33-2.364,0.906-3.671c-0.425-1.307-1.532-2.24-2.892-2.438l-12.092-1.757 c-0.515-0.075-0.96-0.398-1.19-0.865L28.182,3.043c-0.607-1.231-1.839-1.996-3.212-1.996c-1.372,0-2.604,0.765-3.211,1.996 L16.352,14c-0.23,0.467-0.676,0.79-1.191,0.865L3.069,16.622c-1.359,0.197-2.467,1.131-2.892,2.438 c-0.424,1.307-0.077,2.713,0.906,3.671l8.749,8.528c0.373,0.364,0.544,0.888,0.456,1.4L8.224,44.701 c-0.183,1.06,0.095,2.091,0.781,2.904c1.066,1.267,2.927,1.653,4.415,0.871l10.814-5.686c0.452-0.237,1.021-0.235,1.472,0 l10.815,5.686c0.526,0.277,1.087,0.417,1.666,0.417c1.057,0,2.059-0.47,2.748-1.288c0.687-0.813,0.964-1.846,0.781-2.904 l-2.065-12.042c-0.088-0.513,0.083-1.036,0.456-1.4L48.856,22.73z"
      })
    )
  );
};

export var StarOutlined = function StarOutlined(props) {
  return React.createElement(
    "svg",
    _extends({}, props, {
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 54 52",
      xmlSpace: "preserve" }),
    React.createElement(
      "g",
      { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
      React.createElement(
        "g",
        { id: "star-(1)", transform: "translate(1.000000, 2.000000)", stroke: "#000000", strokeWidth: "5" },
        React.createElement("path", {
          d: "M49.856,21.73 C50.839,20.772 51.186,19.366 50.762,18.059 C50.337,16.752 49.23,15.819 47.87,15.621 L35.778,13.864 C35.263,13.789 34.818,13.466 34.588,12.999 L29.182,2.043 C28.575,0.812 27.343,0.047 25.97,0.047 C24.598,0.047 23.366,0.812 22.759,2.043 L17.352,13 C17.122,13.467 16.676,13.79 16.161,13.865 L4.069,15.622 C2.71,15.819 1.602,16.753 1.177,18.06 C0.753,19.367 1.1,20.773 2.083,21.731 L10.832,30.259 C11.205,30.623 11.376,31.147 11.288,31.659 L9.224,43.701 C9.041,44.761 9.319,45.792 10.005,46.605 C11.071,47.872 12.932,48.258 14.42,47.476 L25.234,41.79 C25.686,41.553 26.255,41.555 26.706,41.79 L37.521,47.476 C38.047,47.753 38.608,47.893 39.187,47.893 C40.244,47.893 41.246,47.423 41.935,46.605 C42.622,45.792 42.899,44.759 42.716,43.701 L40.651,31.659 C40.563,31.146 40.734,30.623 41.107,30.259 L49.856,21.73 Z",
          id: "Path"
        })
      )
    )
  );
};

export var Hourglass = function Hourglass(props) {
  return React.createElement(
    "svg",
    _extends({}, props, {
      "aria-hidden": "true",
      focusable: "false",
      "data-prefix": "fas",
      "data-icon": "hourglass",
      className: "svg-inline--fa fa-hourglass fa-w-12",
      role: "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 384 512" }),
    React.createElement("path", {
      fill: "currentColor",
      d: "M360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64z"
    })
  );
};

export var HourglassEnd = function HourglassEnd(props) {
  return React.createElement(
    "svg",
    _extends({}, props, {
      "aria-hidden": "true",
      focusable: "false",
      "data-prefix": "fas",
      "data-icon": "hourglass-end",
      className: "svg-inline--fa fa-hourglass-end fa-w-12",
      role: "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 384 512" }),
    React.createElement("path", {
      fill: "currentColor",
      d: "M360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64zM192 208c-57.787 0-104-66.518-104-144h208c0 77.945-46.51 144-104 144z"
    })
  );
};

export var QuestionMark = function QuestionMark(props) {
  return React.createElement(
    "svg",
    _extends({}, props, {
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 31.357 31.357",
      xmlSpace: "preserve" }),
    React.createElement(
      "g",
      null,
      React.createElement("path", {
        d: "M15.255,0c5.424,0,10.764,2.498,10.764,8.473c0,5.51-6.314,7.629-7.67,9.62c-1.018,1.481-0.678,3.562-3.475,3.562 c-1.822,0-2.712-1.482-2.712-2.838c0-5.046,7.414-6.188,7.414-10.343c0-2.287-1.522-3.643-4.066-3.643 c-5.424,0-3.306,5.592-7.414,5.592c-1.483,0-2.756-0.89-2.756-2.584C5.339,3.683,10.084,0,15.255,0z M15.044,24.406 c1.904,0,3.475,1.566,3.475,3.476c0,1.91-1.568,3.476-3.475,3.476c-1.907,0-3.476-1.564-3.476-3.476 C11.568,25.973,13.137,24.406,15.044,24.406z"
      })
    )
  );
};

export var Detail = function Detail(props) {
  return React.createElement(
    "svg",
    _extends({}, props, {
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 16 16",
      xmlSpace: "preserve" }),
    React.createElement(
      "g",
      null,
      React.createElement("path", {
        d: "M14.9115282,28 C13.3034769,28 12,26.6987765 12,25.0915691 L12,24.0012186 C12,22.9975503 12.8155428,22.1818182 13.8169056,22.1818182 L16.3636364,22.1818182 L16.3636364,13.8205459 C16.3636364,12.8164166 17.1790084,12 18.180542,12 L26.1830944,12 C27.1874164,12 28,12.8145964 28,13.8205459 L28,25.0911925 C28,26.6983697 26.6974259,28 25.0884718,28 L14.9115282,28 Z M26.5454545,25.0911925 L26.5454545,13.8205459 C26.5454545,13.6171152 26.3832865,13.4545455 26.1830944,13.4545455 L18.180542,13.4545455 C17.9827488,13.4545455 17.8181818,13.6193233 17.8181818,13.8205459 L17.8181818,22.1818182 L21.821392,22.1818182 C22.8230532,22.1818182 23.6363636,22.9976013 23.6363636,24.0013828 L23.6363636,25.0929803 C23.6363636,25.894122 24.2869538,26.544141 25.0909086,26.5454525 C25.8956512,26.544142 26.5454545,25.8939999 26.5454545,25.0911925 Z M22.1818182,25.0929803 L22.1818182,24.0013828 C22.1818182,23.7999378 22.0187398,23.6363636 21.821392,23.6363636 L13.8169056,23.6363636 C13.6189417,23.6363636 13.4545455,23.800798 13.4545455,24.0012186 L13.4545455,25.0915691 C13.4545455,25.8948893 14.1062373,26.5454545 14.9115282,26.5454545 L22.5706715,26.5454545 C22.3233576,26.1181503 22.1818182,25.6221157 22.1818182,25.0929803 Z M20,16.7272727 C19.5983384,16.7272727 19.2727273,16.4016616 19.2727273,16 C19.2727273,15.5983384 19.5983384,15.2727273 20,15.2727273 L24.3636364,15.2727273 C24.765298,15.2727273 25.0909091,15.5983384 25.0909091,16 C25.0909091,16.4016616 24.765298,16.7272727 24.3636364,16.7272727 L20,16.7272727 Z M20,19.2727273 C19.5983384,19.2727273 19.2727273,18.9471162 19.2727273,18.5454545 C19.2727273,18.1437929 19.5983384,17.8181818 20,17.8181818 L22.1818182,17.8181818 C22.5834798,17.8181818 22.9090909,18.1437929 22.9090909,18.5454545 C22.9090909,18.9471162 22.5834798,19.2727273 22.1818182,19.2727273 L20,19.2727273 Z",
        transform: "translate(-12 -12)"
      })
    )
  );
};

export var BurgerMenu = function BurgerMenu(props) {
  return React.createElement(
    "svg",
    _extends({}, props, {
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 124 124",
      xmlSpace: "preserve" }),
    React.createElement(
      "g",
      null,
      React.createElement("path", { d: "M112,6H12C5.4,6,0,11.4,0,18s5.4,12,12,12h100c6.6,0,12-5.4,12-12S118.6,6,112,6z" }),
      React.createElement("path", { d: "M112,50H12C5.4,50,0,55.4,0,62c0,6.6,5.4,12,12,12h100c6.6,0,12-5.4,12-12C124,55.4,118.6,50,112,50z" }),
      React.createElement("path", { d: "M112,94H12c-6.6,0-12,5.4-12,12s5.4,12,12,12h100c6.6,0,12-5.4,12-12S118.6,94,112,94z" })
    )
  );
};

export var Edit = function Edit(props) {
  return React.createElement(
    "svg",
    _extends({}, props, {
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 512 512",
      xmlSpace: "preserve" }),
    React.createElement("path", {
      fill: "currentColor",
      d: "M290.74 93.24l128.02 128.02-277.99 277.99-114.14 12.6C11.35 513.54-1.56 500.62.14 485.34l12.7-114.22 277.9-277.88zm207.2-19.06l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.76 18.75-49.16 0-67.91z"
    })
  );
};

/* ******************** Editor Toolbar Icons ******************** */

export var EditorBold = function EditorBold(props) {
  return React.createElement(
    "svg",
    _extends({}, props, {
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      width: "12px",
      height: "12px",
      viewBox: "0 0 10 12",
      xmlSpace: "preserve" }),
    React.createElement(
      "g",
      { stroke: "none", strokeWidth: "1", fillRule: "evenodd" },
      React.createElement(
        "g",
        { transform: "translate(-913.000000, -698.000000)" },
        React.createElement(
          "g",
          { transform: "translate(840.000000, 0.000000)" },
          React.createElement(
            "g",
            { transform: "translate(48.000000, 520.000000)" },
            React.createElement(
              "g",
              { transform: "translate(1.000000, 160.000000)" },
              React.createElement("path", { d: "M31.948,23.204 C33.11,23.677 34,24.966 34,26.5 C34,28.433 32.593,30 31,30 L27,30 L24,30 L24,29.25 L24.718,29.25 C25.165,29.25 25,28.414 25,28 L25,20 C25,19.586 25.165,18.75 24.718,18.75 L24,18.75 L24,18 L27,18 L30,18 C31.56,18 33.01,19.343 33.01,21 C33.01,21.875 32.579,22.656 31.948,23.204 Z M27.602,19 C27.74,19 27.877,19.015 28.013,19.037 L28.013,22.963 C27.877,22.985 27.74,23 27.602,23 L28.013,23 L28.013,22.963 C29.063,22.79 29.988,21.979 29.988,21 C29.988,20.021 29.063,19.21 28.013,19.037 L28.013,19 L27.602,19 Z M29,29 C30.138,29 31,27.881 31,26.5 C31,25.119 30.138,24 29,24 L28,24 L28,29 L29,29 Z" })
            )
          )
        )
      )
    )
  );
};

export var EditorUnderline = function EditorUnderline(props) {
  return React.createElement(
    "svg",
    _extends({}, props, {
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      width: "12px",
      height: "12px",
      viewBox: "0 0 12 12",
      xmlSpace: "preserve" }),
    React.createElement(
      "g",
      { stroke: "none", strokeWidth: "1", fillRule: "evenodd" },
      React.createElement(
        "g",
        { transform: "translate(-979.000000, -698.000000)" },
        React.createElement(
          "g",
          { transform: "translate(840.000000, 0.000000)" },
          React.createElement(
            "g",
            { transform: "translate(48.000000, 520.000000)" },
            React.createElement(
              "g",
              { transform: "translate(1.000000, 160.000000)" },
              React.createElement("path", { d: "M91,30 L91,29 L101,29 L101,30 L91,30 Z M98,19 L98,18 L102,18 L102,19 C101.603,19.105 101,19.663 101,20 L101,24 C101,24 101.091,28 96,28 C90.909,28 91,24 91,24 L91,20 C91,19.683 90.376,19.109 90,19 L90,18 L95,18 L95,19 C94.592,19 94,19.561 94,20 L94,24 C94,24 93.867,26 97,26 C98.702,26 99,24 99,24 L99,20 C99,19.586 98.414,19 98,19 Z" })
            )
          )
        )
      )
    )
  );
};

export var EditorItalic = function EditorItalic(props) {
  return React.createElement(
    "svg",
    _extends({}, props, {
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      width: "12px",
      height: "12px",
      viewBox: "0 0 438.543 438.543",
      xmlSpace: "preserve" }),
    React.createElement(
      "g",
      null,
      React.createElement("path", {
        d: "M355.172,0.715c-6.659,0.478-13.134,0.909-19.417,1.287c-28.171,1.709-48.54,2.568-61.099,2.568 c-6.472,0-13.422-0.193-20.842-0.571L163.312,0l-5.426,29.408c1.902,0.378,5.52,0.762,10.85,1.143 c19.602,1.138,33.308,3.806,41.112,7.993v10.85l-2.284,14.272l-6.28,38.544l-4.57,17.988l-8.28,44.824c0,0.193-0.334,1.288-1,3.287 c-0.666,1.997-1.524,4.899-2.568,8.705c-1.049,3.809-2.236,8.235-3.571,13.278c-1.335,5.042-2.856,11.421-4.57,19.13 c-1.713,7.707-3.332,15.751-4.853,24.124l-3.428,18.274l-15.986,76.517l-7.71,39.677c-2.285,12.189-6.184,21.802-11.704,28.838 c-7.614,3.81-18.654,7.519-33.12,11.14c-13.894,3.613-21.221,5.517-21.982,5.708l-4.853,24.273 c4.565-0.38,13.891-1.235,27.978-2.573c25.315-2.283,41.874-3.33,49.676-3.139l56.532,0.568 c23.979,2.478,37.777,4.093,41.391,4.859c3.617,0.568,6.283,0.855,7.994,0.855c3.429,0,7.423-0.191,11.991-0.571 c0.951-0.188,3.142-0.284,6.567-0.284c0.38-1.902,1.235-5.808,2.569-11.711c1.137-5.52,1.804-11.039,1.999-16.562 c-5.715-0.948-11.991-1.903-18.85-2.848c-10.461-1.143-21.792-3.145-33.975-5.996c-0.564-3.805-0.661-6.375-0.281-7.71l3.43-12.847 l12.278-67.091l10.849-45.111l17.418-88.793c4.183-20.367,10.466-49.484,18.847-87.366c0.763-7.232,1.995-15.037,3.713-23.413 c2.282-10.848,4.571-19.221,6.851-25.125c7.043-2.853,16.659-5.802,28.836-8.848c10.286-2.281,20.655-5.232,31.121-8.848 c1.146-4.188,2.389-9.041,3.716-14.561c0.767-3.619,1.335-7.233,1.711-10.848C365.261,0.003,361.832,0.24,355.172,0.715z"
      })
    )
  );
};

export var EditorSquareList = function EditorSquareList(props) {
  return React.createElement(
    "svg",
    _extends({}, props, {
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      width: "13px",
      height: "13px",
      viewBox: "0 0 17 14",
      xmlSpace: "preserve" }),
    React.createElement(
      "g",
      { stroke: "none", strokeWidth: "1", fillRule: "evenodd" },
      React.createElement(
        "g",
        { transform: "translate(-1091.000000, -697.000000)" },
        React.createElement(
          "g",
          { transform: "translate(840.000000, 0.000000)" },
          React.createElement(
            "g",
            { transform: "translate(48.000000, 520.000000)" },
            React.createElement(
              "g",
              { transform: "translate(1.000000, 160.000000)" },
              React.createElement("path", {
                d: "M207.475649,25 C208.027649,25 208.475649,25.448 208.475649,26 L208.475649,30 C208.475649,30.552 208.027649,31 207.475649,31 L203.475649,31 C202.923649,31 202.475649,30.552 202.475649,30 L202.475649,26 C202.475649,25.448 202.923649,25 203.475649,25 L207.475649,25 Z M206.475649,28.333 L206.475649,27.667 C206.475649,27.298 206.177649,27 205.808649,27 L205.142649,27 C204.774649,27 204.475649,27.298 204.475649,27.667 L204.475649,28.333 C204.475649,28.702 204.774649,29 205.142649,29 L205.808649,29 C206.177649,29 206.475649,28.702 206.475649,28.333 Z M203.475649,17 L207.475649,17 C208.027649,17 208.475649,17.448 208.475649,18 L208.475649,22 C208.475649,22.552 208.027649,23 207.475649,23 L203.475649,23 C202.923649,23 202.475649,22.552 202.475649,22 L202.475649,18 C202.475649,17.448 202.923649,17 203.475649,17 Z M206.475649,20.333 L206.475649,19.667 C206.475649,19.299 206.177649,19 205.808649,19 L205.142649,19 C204.773649,19 204.475649,19.299 204.475649,19.667 L204.475649,20.333 C204.475649,20.702 204.773649,21 205.142649,21 L205.808649,21 C206.177649,21 206.475649,20.702 206.475649,20.333 Z M217.475649,25 C218.027649,25 218.475649,25.448 218.475649,26 C218.475649,26.552 218.027649,27 217.475649,27 L210.475649,27 C209.923649,27 209.475649,26.552 209.475649,26 C209.475649,25.448 209.923649,25 210.475649,25 L217.475649,25 Z M217.475649,17 C218.027649,17 218.475649,17.448 218.475649,18 C218.475649,18.552 218.027649,19 217.475649,19 L210.475649,19 C209.923649,19 209.475649,18.552 209.475649,18 C209.475649,17.448 209.923649,17 210.475649,17 L217.475649,17 Z M217.475649,21 C218.027649,21 218.475649,21.448 218.475649,22 C218.475649,22.552 218.027649,23 217.475649,23 L210.475649,23 C209.923649,23 209.475649,22.552 209.475649,22 C209.475649,21.448 209.923649,21 210.475649,21 L217.475649,21 Z M217.475649,29 C218.027649,29 218.475649,29.448 218.475649,30 C218.475649,30.552 218.027649,31 217.475649,31 L210.475649,31 C209.923649,31 209.475649,30.552 209.475649,30 C209.475649,29.448 209.923649,29 210.475649,29 L217.475649,29 Z",
                id: "editor/list"
              })
            )
          )
        )
      )
    )
  );
};

export var EditorNumberList = function EditorNumberList(props) {
  return React.createElement(
    "svg",
    _extends({}, props, {
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      width: "13px",
      height: "13px",
      viewBox: "0 0 16 14",
      xmlSpace: "preserve" }),
    React.createElement(
      "g",
      { stroke: "none", strokeWidth: "1", fillRule: "evenodd" },
      React.createElement(
        "g",
        { transform: "translate(-1131.000000, -697.000000)" },
        React.createElement(
          "g",
          { transform: "translate(840.000000, 0.000000)" },
          React.createElement(
            "g",
            { transform: "translate(48.000000, 520.000000)" },
            React.createElement(
              "g",
              { transform: "translate(1.000000, 160.000000)" },
              React.createElement("path", { d: "M246.101649,28.658 C245.540649,29.214 245.114649,29.558 244.395649,30.069 L247.492649,30.052 L247.492649,30.996 L242.476649,30.996 L242.476649,30.008 C243.172649,29.514 243.924649,28.94 244.407649,28.517 C245.316649,27.731 245.675649,27.255 245.675649,26.814 C245.675649,26.311 245.203649,25.976 244.496649,25.976 C243.958649,25.976 243.352649,26.143 242.746649,26.47 L242.622649,25.429 C243.497649,25.12 244.103649,25.014 244.912649,25.014 C245.630649,25.014 246.135649,25.137 246.550649,25.411 C247.021649,25.72 247.279649,26.17 247.279649,26.681 C247.279649,27.29 246.976649,27.802 246.101649,28.658 Z M244.475649,23 L244.475649,18 L242.475649,18 L244.475649,17 L246.475649,17 L246.475649,23 L244.475649,23 Z M256.475649,25 C257.027649,25 257.475649,25.448 257.475649,26 C257.475649,26.552 257.027649,27 256.475649,27 L249.475649,27 C248.923649,27 248.475649,26.552 248.475649,26 C248.475649,25.448 248.923649,25 249.475649,25 L256.475649,25 Z M256.475649,17 C257.027649,17 257.475649,17.448 257.475649,18 C257.475649,18.552 257.027649,19 256.475649,19 L249.475649,19 C248.923649,19 248.475649,18.552 248.475649,18 C248.475649,17.448 248.923649,17 249.475649,17 L256.475649,17 Z M256.475649,21 C257.027649,21 257.475649,21.448 257.475649,22 C257.475649,22.552 257.027649,23 256.475649,23 L249.475649,23 C248.923649,23 248.475649,22.552 248.475649,22 C248.475649,21.448 248.923649,21 249.475649,21 L256.475649,21 Z M256.475649,29 C257.027649,29 257.475649,29.448 257.475649,30 C257.475649,30.552 257.027649,31 256.475649,31 L249.475649,31 C248.923649,31 248.475649,30.552 248.475649,30 C248.475649,29.448 248.923649,29 249.475649,29 L256.475649,29 Z" })
            )
          )
        )
      )
    )
  );
};

export var ExternalLink = function ExternalLink(props) {
  return React.createElement(
    "svg",
    _extends({}, props, {
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 511.626 511.627",
      xmlSpace: "preserve" }),
    React.createElement(
      "g",
      null,
      React.createElement("path", {
        d: "M392.857,292.354h-18.274c-2.669,0-4.859,0.855-6.563,2.573c-1.718,1.708-2.573,3.897-2.573,6.563v91.361 c0,12.563-4.47,23.315-13.415,32.262c-8.945,8.945-19.701,13.414-32.264,13.414H82.224c-12.562,0-23.317-4.469-32.264-13.414 c-8.945-8.946-13.417-19.698-13.417-32.262V155.31c0-12.562,4.471-23.313,13.417-32.259c8.947-8.947,19.702-13.418,32.264-13.418 h200.994c2.669,0,4.859-0.859,6.57-2.57c1.711-1.713,2.566-3.9,2.566-6.567V82.221c0-2.662-0.855-4.853-2.566-6.563 c-1.711-1.713-3.901-2.568-6.57-2.568H82.224c-22.648,0-42.016,8.042-58.102,24.125C8.042,113.297,0,132.665,0,155.313v237.542 c0,22.647,8.042,42.018,24.123,58.095c16.086,16.084,35.454,24.13,58.102,24.13h237.543c22.647,0,42.017-8.046,58.101-24.13 c16.085-16.077,24.127-35.447,24.127-58.095v-91.358c0-2.669-0.856-4.859-2.574-6.57 C397.709,293.209,395.519,292.354,392.857,292.354z"
      }),
      React.createElement("path", {
        d: "M506.199,41.971c-3.617-3.617-7.905-5.424-12.85-5.424H347.171c-4.948,0-9.233,1.807-12.847,5.424 c-3.617,3.615-5.428,7.898-5.428,12.847s1.811,9.233,5.428,12.85l50.247,50.248L198.424,304.067 c-1.906,1.903-2.856,4.093-2.856,6.563c0,2.479,0.953,4.668,2.856,6.571l32.548,32.544c1.903,1.903,4.093,2.852,6.567,2.852 s4.665-0.948,6.567-2.852l186.148-186.148l50.251,50.248c3.614,3.617,7.898,5.426,12.847,5.426s9.233-1.809,12.851-5.426 c3.617-3.616,5.424-7.898,5.424-12.847V54.818C511.626,49.866,509.813,45.586,506.199,41.971z"
      })
    )
  );
};

export var More = function More(props) {
  return React.createElement(
    "svg",
    _extends({}, props, {
      width: "16px",
      height: "4px",
      viewBox: "0 0 16 4",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink" }),
    React.createElement(
      "g",
      { id: "04-\u2013-Task-\u2013-Details", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
      React.createElement(
        "g",
        {
          id: "00_02_01--GipsyBot--Task",
          transform: "translate(-812.000000, -522.000000)",
          fill: "#ADABBC",
          fillRule: "nonzero" },
        React.createElement(
          "g",
          { id: "Task", transform: "translate(140.000000, 48.000000)" },
          React.createElement(
            "g",
            { id: "Activity", transform: "translate(0.000000, 40.000000)" },
            React.createElement(
              "g",
              { transform: "translate(32.000000, 208.000000)", id: "Comment" },
              React.createElement(
                "g",
                { transform: "translate(0.000000, 220.000000)" },
                React.createElement(
                  "g",
                  { id: "Icon/More", transform: "translate(640.000000, 0.000000)" },
                  React.createElement("path", {
                    d: "M2,10 C0.8954305,10 0,9.1045695 0,8 C0,6.8954305 0.8954305,6 2,6 C3.1045695,6 4,6.8954305 4,8 C4,9.1045695 3.1045695,10 2,10 Z M8,10 C6.8954305,10 6,9.1045695 6,8 C6,6.8954305 6.8954305,6 8,6 C9.1045695,6 10,6.8954305 10,8 C10,9.1045695 9.1045695,10 8,10 Z M14,10 C12.8954305,10 12,9.1045695 12,8 C12,6.8954305 12.8954305,6 14,6 C15.1045695,6 16,6.8954305 16,8 C16,9.1045695 15.1045695,10 14,10 Z",
                    id: "Icon/16/More"
                  })
                )
              )
            )
          )
        )
      )
    )
  );
};

export var ExclamationTriangle = function ExclamationTriangle(props) {
  return React.createElement(
    "svg",
    _extends({}, props, {
      "aria-hidden": "true",
      focusable: "false",
      "data-prefix": "fas",
      "data-icon": "exclamation-triangle",
      className: "svg-inline--fa fa-exclamation-triangle fa-w-18",
      role: "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 576 512" }),
    React.createElement("path", {
      fill: "currentColor",
      d: "M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"
    })
  );
};

export var AddUser = function AddUser(props) {
  return React.createElement(
    "svg",
    _extends({}, props, { width: "18px", height: "18px", viewBox: "0 0 18 18", version: "1.1", xmlns: "http://www.w3.org/2000/svg" }),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "linearGradient",
        { x1: "50%", y1: "0%", x2: "50%", y2: "100%", id: "linearGradient-1" },
        React.createElement("stop", { stopColor: "#744AFF", offset: "0%" }),
        React.createElement("stop", { stopColor: "#643FDB", offset: "100%" })
      )
    ),
    React.createElement(
      "g",
      { id: "12---Team", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
      React.createElement(
        "g",
        { id: "00_38_11--GipsyBot--team", transform: "translate(-119.000000, -755.000000)", fill: "url(#linearGradient-1)" },
        React.createElement(
          "g",
          { id: "Navigation/Users", transform: "translate(80.000000, 0.000000)" },
          React.createElement(
            "g",
            { id: "Add-user", transform: "translate(8.000000, 728.000000)" },
            React.createElement(
              "g",
              { id: "Icon/24/Add-user", transform: "translate(28.000000, 24.000000)" },
              React.createElement("path", { d: "M12.2804297,12.9480469 C11.5257318,12.8323793 10.9922553,12.7745455 10.68,12.7745455 C9.42920727,12.7745455 7.97838545,13.1278255 6.62496,13.7052218 C6.06048,13.9460945 5.54941091,14.2121018 5.16261818,14.4610036 C4.99016727,14.5720145 4.85018182,14.6746473 4.75243636,14.7601745 C4.71613091,14.7922909 4.68820364,14.81952 4.66970182,14.8401164 C4.62257455,14.9636945 4.56322909,15.2384291 4.51191273,15.5892655 C4.47735273,15.8231564 4.44802909,16.0758982 4.42359273,16.3293382 C4.41102545,16.4598982 4.40194909,16.5653236 4.39671273,16.6333964 C4.4066852,16.817855 4.55863481,16.9626126 4.74336,16.9636364 C6.9552,16.9636364 9.27892375,16.9636364 10.3848437,16.9636364 C10.3848437,17.2545455 10.3574583,17.5241458 10.3026875,17.7724375 C10.2479167,18.0207292 10.0536875,18.2165833 9.72,18.36 C8.61408,18.36 6.9552,18.36 4.74336,18.36 C3.78019015,18.3588442 2.99999931,17.577716 3,16.6145455 L3.00174545,16.5649745 L3.00977455,16.4605964 C3.0396,16.1014635 3.0797621,15.7432641 3.13021091,15.3864436 C3.20491636,14.8774691 3.29079273,14.4941673 3.41297455,14.22816 C3.94952727,13.0632436 7.89949091,11.3781818 10.68,11.3781818 C11.3662702,11.3781818 12.1237805,11.4808315 12.8836262,11.6529748 C12.8850304,11.8451452 12.8107227,12.1161426 12.6607031,12.4659668 C12.5106836,12.815791 12.3839258,12.9764844 12.2804297,12.9480469 Z M10.68,10.68 C8.55927273,10.68 6.84,8.96072727 6.84,6.84 C6.84,4.71927273 8.55927273,3 10.68,3 C12.8007273,3 14.52,4.71927273 14.52,6.84 C14.52,8.96072727 12.8007273,10.68 10.68,10.68 Z M12.7962512,8.0618182 C13.2327648,7.30575447 13.2327648,6.37424553 12.7962512,5.6181818 C12.3597376,4.86211807 11.5530272,4.39636362 10.68,4.39636364 C9.33041692,4.39636366 8.23636369,5.49041692 8.23636369,6.84 C8.23636369,8.18958308 9.33041692,9.28363634 10.68,9.28363636 C11.5530272,9.28363638 12.3597376,8.81788193 12.7962512,8.0618182 Z M17.16,15.72 L20.28,15.72 C20.677645,15.72 21,16.042355 21,16.44 C21,16.837645 20.677645,17.16 20.28,17.16 L17.16,17.16 L17.16,20.28 C17.16,20.677645 16.837645,21 16.44,21 C16.042355,21 15.72,20.677645 15.72,20.28 L15.72,17.16 L12.6,17.16 C12.202355,17.16 11.88,16.837645 11.88,16.44 C11.88,16.042355 12.202355,15.72 12.6,15.72 L15.72,15.72 L15.72,12.6 C15.72,12.202355 16.042355,11.88 16.44,11.88 C16.837645,11.88 17.16,12.202355 17.16,12.6 L17.16,15.72 Z" })
            )
          )
        )
      )
    )
  );
};

// https://fontawesome.com/icons/square?style=regular
export var EmptyCheckbox = function EmptyCheckbox(props) {
  return React.createElement(
    "svg",
    _extends({}, props, {
      "aria-hidden": "true",
      focusable: "false",
      "data-prefix": "far",
      "data-icon": "square",
      className: "svg-inline--fa fa-square fa-w-14",
      role: "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 448 512" }),
    React.createElement("path", {
      fill: "currentColor",
      d: "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V86c0-3.3 2.7-6 6-6h340c3.3 0 6 2.7 6 6v340c0 3.3-2.7 6-6 6z"
    })
  );
};

export var CheckSquare = function CheckSquare(props) {
  return React.createElement(
    "svg",
    _extends({}, props, {
      "aria-hidden": "true",
      focusable: "false",
      "data-prefix": "far",
      "data-icon": "check-square",
      className: "svg-inline--fa fa-check-square fa-w-14",
      role: "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 448 512" }),
    React.createElement("path", {
      fill: "currentColor",
      d: "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm0 400H48V80h352v352zm-35.864-241.724L191.547 361.48c-4.705 4.667-12.303 4.637-16.97-.068l-90.781-91.516c-4.667-4.705-4.637-12.303.069-16.971l22.719-22.536c4.705-4.667 12.303-4.637 16.97.069l59.792 60.277 141.352-140.216c4.705-4.667 12.303-4.637 16.97.068l22.536 22.718c4.667 4.706 4.637 12.304-.068 16.971z" })
  );
};
//# sourceMappingURL=icons.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/Icon/icons.js
// module id = 418
// module chunks = 0